import PropTypes from 'prop-types';
import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import ReactModal from 'react-modal';
import VM from 'scratch-vm';
import {injectIntl, intlShape} from 'react-intl';

import ErrorBoundaryHOC from '../lib/error-boundary-hoc.jsx';
import {
    getIsError,
    getIsShowingProject,
    LoadingStates
} from '../reducers/project-state';

import {
    activateTab,
    BLOCKS_TAB_INDEX,
    COSTUMES_TAB_INDEX,
    SOUNDS_TAB_INDEX
} from '../reducers/editor-tab';

import {
    closeCostumeLibrary,
    closeBackdropLibrary,
    closeTelemetryModal,
    openExtensionLibrary
} from '../reducers/modals';

import FontLoaderHOC from '../lib/font-loader-hoc.jsx';
import LocalizationHOC from '../lib/localization-hoc.jsx';
import SBFileUploaderHOC from '../lib/sb-file-uploader-hoc.jsx';
// import SBFileLocalUploader from '../lib/sb-file-local-uploader.jsx';
import ProjectFetcherHOC from '../lib/project-fetcher-hoc.jsx';
import TitledHOC from '../lib/titled-hoc.jsx';
import ProjectSaverHOC from '../lib/project-saver-hoc.jsx';
import QueryParserHOC from '../lib/query-parser-hoc.jsx';
import storage from '../lib/storage';
import vmListenerHOC from '../lib/vm-listener-hoc.jsx';
import vmManagerHOC from '../lib/vm-manager-hoc.jsx';
import cloudManagerHOC from '../lib/cloud-manager-hoc.jsx';
import systemPreferencesHOC from '../lib/system-preferences-hoc.jsx';

import GUIComponent from '../components/gui/gui.jsx';
import {setIsScratchDesktop} from '../lib/isScratchDesktop.js';
import bindAll from 'lodash.bindall';

const {RequestMetadata, setMetadata, unsetMetadata} = storage.scratchFetch;

const setProjectIdMetadata = projectId => {
    // If project ID is '0' or zero, it's not a real project ID. In that case, remove the project ID metadata.
    // Same if it's null undefined.
    if (projectId && projectId !== '0') {
        setMetadata(RequestMetadata.ProjectId, projectId);
    } else {
        unsetMetadata(RequestMetadata.ProjectId);
    }
};

class GUI extends React.Component {

    // 新增constructor
    constructor (props) {
        super(props);
        this.state = {
            // rscBaseUrl: 'http://183.162.197.94:9876', // 科技厅
            // rscBaseUrl: 'http://139.224.114.17:7777', // 测试使用
            rscBaseUrl: 'https://ypc.zhongkediman.com', // 安徽省pc考试系统
            // rscBaseUrl: 'https://ypc-backstage.zhongkediman.com', // 全国编程平台
            token: '',
            timer: null,
            qid: '',
            userId: '',
            matchId: '',
            examCard: '',
            questionType: ''
        };
        // this.handleRscMessage = this.handleRscMessage.bind(this);
        bindAll(this, [
            'handleRscMessage',
            'checkForNewFile'
            // 'downloadProject',
            // 'storageFile'
        ]);
    }
    componentDidMount () {
        // 新增一行代码
        // window.addEventListener('message', this.handleRscMessage);
        
        // window.addEventListener('load', this.storageFile);
        setIsScratchDesktop(this.props.isScratchDesktop);

        // 这行代码是初始化加载 如果需要保存就要注释
        this.props.onStorageInit(storage);

        this.props.onVmInit(this.props.vm);
        // 更改了一行代码 setProjectIdMetadata('dadada'); 这个需要保存更改的代码
        setProjectIdMetadata('');
    }
    componentDidUpdate (prevProps) {

        if (this.props.projectId !== prevProps.projectId) {
            if (this.props.projectId !== null) {
                this.props.onUpdateProjectId(this.props.projectId);
            }
            setProjectIdMetadata(this.props.projectId);
        }
        if (this.props.isShowingProject && !prevProps.isShowingProject) {
            // this only notifies container when a project changes from not yet loaded to loaded
            // At this time the project view in www doesn't need to know when a project is unloaded
            this.props.onProjectLoaded();
        }

        // 新增代码判断
        // if (prevState.qid !== '' && prevState.qid !== this.state.qid) {
        //     console.log('先前的QID:', prevState.qid);
        //     if (this.state.questionType === '6'){
        //         this.downloadProject(this.state.userId, prevState.qid);
        //     }
        // }
    }

    // 新增代码
    componentWillUnmount () {
        // window.removeEventListener('message', this.handleRscMessage);
        // window.removeEventListener('load', this.storageFile);
        // window.removeEventListener('beforeunload', event => {
        //     // 显示确认对话框
        //     event.preventDefault();
        //     event.returnValue = '';
        // });
    }

    // storageFile (){
    //     let timer = null;
    //     clearInterval(timer);
    //     timer = setInterval(() => {
    //         if (this.state.qid !== ''){
    //             this.downloadProject(this.state.userId, this.state.qid);
    //         }
    //     }, 5000);
    // }

    // 新增接收消息
    handleRscMessage (event) {
        const data = event.data;
        if (data && typeof (data) === 'string' && data.includes('flag')) {
            const qid = JSON.parse(data).questionID;
            const examCard = JSON.parse(data).examCard;
            const questionType = JSON.parse(data).questionType;
            sessionStorage.setItem('examCard', JSON.parse(data).examCard);
            sessionStorage.setItem('qid', JSON.parse(data).questionID);
            this.setState({qid, questionType, examCard});
            clearTimeout(this.state.timer);
            const newTimer = setTimeout(() => {
                this.checkForNewFile(qid, examCard);
            }, 800);
            this.setState({timer: newTimer});
        } else {
            this.props.onStorageInit(storage);
        }
    }

    // 新增代码用于判断是否一上来就加载文件
    checkForNewFile = async (qid, examCard) => {
        const url = `${this.state.rscBaseUrl}/v2/exam/getScratchFile?examCard=${examCard}&questionId=${qid}`;
        // const url = `${this.state.rscBaseUrl}/v2/doQuestion/getScratchFile?questionId=${qid}`;
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/x.scratch.sb3'
                    // 'token': examCard
                }
            });
    
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
    
            const blob = await response.blob();
            // const file = new File([blob], 'project.sb3', {type: 'application/x.scratch.sb3'});
            const files = new File([blob], 'filename.sb3', {
                type: 'application/octet-stream',
                lastModified: Date.now()
            });
            // console.log('correctedBlob的文件', files);

            const reader = new FileReader();
            reader.onload = async event => {
                const data = new Uint8Array(event.target.result);
                try {
                    await this.props.vm.loadProject(data); // 使用await确保项目加载完成
                    this.props.onProjectLoaded();
                } catch (error) {
                    console.error('Failed to load project:', error);
                }
            };
            reader.readAsArrayBuffer(files);
        } catch (error) {
            console.error('Error checking for new file:', error);
        }
    };
    

    // 新增自动保存的功能
    // downloadProject = (userId, questionId) => {
    //     const url = `${this.state.rscBaseUrl}/competition/commitQues`;
    //     this.props.vm.saveProjectSb3().then(content => {
    //         // 上传文件到服务器
    //         this.uploadFile(url, content, userId, questionId);
    //     })
    //         .catch(error => {
    //             console.error('Failed to save project:', error);
    //         });
    // };

    // 上传到后台
    uploadFile = (url, content, userId, questionId) => {
        const formData = new FormData();
        formData.append('competitionId', this.state.matchId);
        formData.append('questionId', questionId);
        formData.append('questionType', '6');
        formData.append('userId', userId);
        formData.append('scratchFile', new Blob([content], {type: 'application/octet-stream'}), 'examFile');
        fetch(url, {
            method: 'POST',
            body: formData
        }).then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
            .then(data => {
                console.log('File uploaded successfully:', data);
            })
            .catch(error => {
                console.error('Failed to upload file:', error);
            });
    };

    render () {
        if (this.props.isError) {
            throw new Error(
                `Error in Scratch GUI [location=${window.location}]: ${this.props.error}`);
        }
        const {
            /* eslint-disable no-unused-vars */
            assetHost,
            cloudHost,
            error,
            isError,
            isScratchDesktop,
            isShowingProject,
            onProjectLoaded,
            onStorageInit,
            onUpdateProjectId,
            onVmInit,
            projectHost,
            projectId,
            /* eslint-enable no-unused-vars */
            children,
            fetchingProject,
            isLoading,
            loadingStateVisible,
            ...componentProps
        } = this.props;
        return (
            <GUIComponent
                loading={fetchingProject || isLoading || loadingStateVisible}
                {...componentProps}
            >
                {children}
            </GUIComponent>
        );
    }
}

GUI.propTypes = {
    assetHost: PropTypes.string,
    children: PropTypes.node,
    cloudHost: PropTypes.string,
    error: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    fetchingProject: PropTypes.bool,
    intl: intlShape,
    isError: PropTypes.bool,
    isLoading: PropTypes.bool,
    isScratchDesktop: PropTypes.bool,
    isShowingProject: PropTypes.bool,
    isTotallyNormal: PropTypes.bool,
    loadingStateVisible: PropTypes.bool,
    onProjectLoaded: PropTypes.func,
    onSeeCommunity: PropTypes.func,
    onStorageInit: PropTypes.func,
    onUpdateProjectId: PropTypes.func,
    onVmInit: PropTypes.func,
    isLoadingUpload: PropTypes.bool,
    isShowingWithoutId: PropTypes.bool,
    loadingState: PropTypes.oneOf(LoadingStates),
    projectHost: PropTypes.string,
    projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    telemetryModalVisible: PropTypes.bool,
    vm: PropTypes.instanceOf(VM).isRequired
};

GUI.defaultProps = {
    isScratchDesktop: false,
    isTotallyNormal: false,
    onStorageInit: storageInstance => storageInstance.addOfficialScratchWebStores(),
    onProjectLoaded: () => {},
    onUpdateProjectId: () => {},
    onVmInit: (/* vm */) => {}
};

const mapStateToProps = state => {
    const loadingState = state.scratchGui.projectState.loadingState;
    return {
        activeTabIndex: state.scratchGui.editorTab.activeTabIndex,
        alertsVisible: state.scratchGui.alerts.visible,
        backdropLibraryVisible: state.scratchGui.modals.backdropLibrary,
        blocksTabVisible: state.scratchGui.editorTab.activeTabIndex === BLOCKS_TAB_INDEX,
        cardsVisible: state.scratchGui.cards.visible,
        connectionModalVisible: state.scratchGui.modals.connectionModal,
        costumeLibraryVisible: state.scratchGui.modals.costumeLibrary,
        costumesTabVisible: state.scratchGui.editorTab.activeTabIndex === COSTUMES_TAB_INDEX,
        error: state.scratchGui.projectState.error,
        isError: getIsError(loadingState),
        isFullScreen: state.scratchGui.mode.isFullScreen,
        isPlayerOnly: state.scratchGui.mode.isPlayerOnly,
        isRtl: state.locales.isRtl,
        isShowingProject: getIsShowingProject(loadingState),
        loadingStateVisible: state.scratchGui.modals.loadingProject,
        projectId: state.scratchGui.projectState.projectId,
        soundsTabVisible: state.scratchGui.editorTab.activeTabIndex === SOUNDS_TAB_INDEX,
        targetIsStage: (
            state.scratchGui.targets.stage &&
            state.scratchGui.targets.stage.id === state.scratchGui.targets.editingTarget
        ),
        telemetryModalVisible: state.scratchGui.modals.telemetryModal,
        tipsLibraryVisible: state.scratchGui.modals.tipsLibrary,
        vm: state.scratchGui.vm
    };
};

const mapDispatchToProps = dispatch => ({
    onExtensionButtonClick: () => dispatch(openExtensionLibrary()),
    onActivateTab: tab => dispatch(activateTab(tab)),
    onActivateCostumesTab: () => dispatch(activateTab(COSTUMES_TAB_INDEX)),
    onActivateSoundsTab: () => dispatch(activateTab(SOUNDS_TAB_INDEX)),
    onRequestCloseBackdropLibrary: () => dispatch(closeBackdropLibrary()),
    onRequestCloseCostumeLibrary: () => dispatch(closeCostumeLibrary()),
    onRequestCloseTelemetryModal: () => dispatch(closeTelemetryModal())
});

const ConnectedGUI = injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(GUI));

// note that redux's 'compose' function is just being used as a general utility to make
// the hierarchy of HOC constructor calls clearer here; it has nothing to do with redux's
// ability to compose reducers.
const WrappedGui = compose(
    LocalizationHOC,
    ErrorBoundaryHOC('Top Level App'),
    FontLoaderHOC,
    QueryParserHOC,
    ProjectFetcherHOC,
    TitledHOC,
    ProjectSaverHOC,
    vmListenerHOC,
    vmManagerHOC,
    SBFileUploaderHOC,
    // SBFileLocalUploader,
    cloudManagerHOC,
    systemPreferencesHOC
)(ConnectedGUI);

WrappedGui.setAppElement = ReactModal.setAppElement;
export default WrappedGui;
